import { RecentlyUsedFont } from "./types/recentlyUsedFont";

export const filterWebFonts = (webFonts: string[], recentlyUsedFonts: RecentlyUsedFont[], fontFamily: string) =>
    webFonts.filter((font) => !recentlyUsedFonts.find((_f) => _f.family === font) && fontFamily !== font);
